<script setup>
// Component Imports
import Navigation from '@/components/mwp/Navigation.vue'
import Footer from '@/components/mwp/Footer.vue'
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <Navigation />
    <main class="flex-grow inline-grid">
      <slot/>
    </main>
    <Footer />
  </div>
</template>